import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav 
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className={`text-2xl font-bold ${isScrolled ? 'text-dark' : 'text-white'}`}>
              引力结构
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <NavLink to="hero" title="首页" isScrolled={isScrolled} />
            <NavLink to="products" title="产品" isScrolled={isScrolled} />
            <NavLink to="about" title="关于我们" isScrolled={isScrolled} />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={toggleMobileMenu}
              className="focus:outline-none"
              aria-label="Toggle menu"
            >
              <svg 
                className={`w-6 h-6 ${isScrolled ? 'text-dark' : 'text-white'}`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-lg mt-2 py-2 px-4 absolute right-4 left-4">
            <div className="flex flex-col space-y-4 py-2">
              <MobileNavLink to="hero" title="首页" onClick={() => setIsMobileMenuOpen(false)} />
              <MobileNavLink to="products" title="产品" onClick={() => setIsMobileMenuOpen(false)} />
              <MobileNavLink to="about" title="关于我们" onClick={() => setIsMobileMenuOpen(false)} />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

const NavLink = ({ to, title, isScrolled }) => (
  <Link
    to={to}
    spy={true}
    smooth={true}
    offset={-70}
    duration={500}
    className={`cursor-pointer font-medium hover:text-primary transition-colors ${
      isScrolled ? 'text-dark' : 'text-white'
    }`}
  >
    {title}
  </Link>
);

const MobileNavLink = ({ to, title, onClick }) => (
  <Link
    to={to}
    spy={true}
    smooth={true}
    offset={-70}
    duration={500}
    className="text-dark font-medium block py-2 hover:text-primary transition-colors"
    onClick={onClick}
  >
    {title}
  </Link>
);

export default Navbar; 